export default class TimeoutError extends Error {
  constructor(e = 'La connexion a expiré, veuillez vérifier votre connexion puis réessayer', { time } = {}) {
    super(e)
    this.name = 'TimeoutError'
    this.time = time
  }
}
